export const findSubsection = (nodes = [], id, path = []) => {
  for (const node of nodes) {
    const nextPath = [...path, node.order];
    if (node.id === id) {
      return { node, path: nextPath };
    }

    const found = findSubsection(node.subsections || [], id, nextPath);
    if (found) {
      return found;
    }
  }

  return null;
};

export const subsectionNumber = (prefix, orderPath = []) =>
  [prefix, ...orderPath.map((order) => Number(order) + 1)]
    .filter(Boolean)
    .join('.');

export const flattenSubsections = (nodes = []) =>
  nodes.flatMap((node) => [
    node,
    ...flattenSubsections(node.subsections || []),
  ]);

export const mapSubsection = (nodes = [], id, updater) =>
  nodes.map((node) => {
    if (node.id === id) {
      return updater(node);
    }

    return {
      ...node,
      subsections: mapSubsection(node.subsections || [], id, updater),
    };
  });
